/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, name: "A", value: { checked: false, price: 0, vat: 0 } },
  { id: 1, name: "B", value: { checked: false, price: 0, vat: 0 } },
  { id: 2, name: "C", value: { checked: false, price: 0, vat: 0 } },
  { id: 3, name: "I", value: { checked: false, price: 0, vat: 0 } },
  { id: 4, name: "I1", value: { checked: false, price: 0, vat: 0 } },
  { id: 5, name: "I1a", value: { checked: false, price: 0, vat: 0 } },
  { id: 6, name: "I2", value: { checked: false, price: 0, vat: 0 } },
  { id: 7, name: "II", value: { checked: false, price: 0, vat: 0 } },
  { id: 8, name: "II1", value: { checked: false, price: 0, vat: 0 } },
  { id: 9, name: "II2", value: { checked: false, price: 0, vat: 0 } },
  { id: 10, name: "II2a", value: { checked: false, price: 0, vat: 0 } },
  { id: 11, name: "II2b", value: { checked: false, price: 0, vat: 0 } },
  { id: 12, name: "II2c", value: { checked: false, price: 0, vat: 0 } },
  { id: 13, name: "II2d", value: { checked: false, price: 0, vat: 0 } },
  { id: 14, name: "II3", value: { checked: false, price: 0, vat: 0 } },
  { id: 15, name: "III", value: { checked: false, price: 0, vat: 0 } },
  { id: 16, name: "IV", value: { checked: false, price: 0, vat: 0 } },
  { id: 17, name: "IV1", value: { checked: false, price: 0, vat: 0 } },
  { id: 18, name: "IV2", value: { checked: false, price: 0, vat: 0 } },
  { id: 19, name: "V", value: { checked: false, price: 0, vat: 0 } },
  { id: 20, name: "VI", value: { checked: false, price: 0, vat: 0 } },
  { id: 21, name: "VI1", value: { checked: false, price: 0, vat: 0 } },
  { id: 22, name: "VI2", value: { checked: false, price: 0, vat: 0 } },
  { id: 23, name: "VI3", value: { checked: false, price: 0, vat: 0 } },
  { id: 24, name: "VI4", value: { checked: false, price: 0, vat: 0 } },
  { id: 25, name: "VI41", value: { checked: false, price: 0, vat: 0 } },
  { id: 26, name: "VI42", value: { checked: false, price: 0, vat: 0 } },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Giá trị hàng hóa, dịch vụ (chưa có thuế GTGT)
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Thuế giá trị gia tăng
              </Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"Thuế giá trị gia tăng chưa được hoàn kỳ trước chuyển sang"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[21]"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable id={0} name="vat" value={data[0].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "transparent", //transparent
                  fontWeight: "bold",
                }}
              >
                {"Thuế giá trị gia tăng đầu vào của dự án đầu tư nhận bàn giao"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[21a]"}
              </Td>
              <Td
                colSpan={2}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable id={1} name="vat" value={data[1].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={5}
                style={{
                  textAlign: "left",
                  background: "transparent", //transparent
                  fontWeight: "bold",
                }}
              >
                {"Kê khai thuế giá trị gia tăng đầu vào của dự án đầu tư"}
              </Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"3.1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent", //transparent
                  fontWeight: "bold",
                }}
              >
                {"Hàng hóa, dịch vụ mua vào trong kỳ"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[22]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={3}
                  name="price"
                  value={data[3].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[23]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable id={3} name="vat" value={data[3].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {""}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent", //transparent
                  fontWeight: 400,
                }}
              >
                {"Trong đó: hàng hóa, dịch vụ nhập khẩu"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[22a]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={4}
                  name="price"
                  value={data[4].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[23a]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={4} name="vat" value={data[4].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={5}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"3.2"}
              </Td>
              <Td
                colSpan={5}
                style={{
                  textAlign: "left",
                  background: "transparent", //transparent
                  fontWeight: "bold",
                }}
              >
                {
                  "Điều chỉnh giá trị và thuế giá trị gia tăng của hàng hóa, dịch vụ mua vào các kỳ trước"
                }
              </Td>
            </tr>
            <tr key={6}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"a"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent", //transparent
                  fontWeight: 400,
                }}
              >
                {"Điều chỉnh tăng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[24]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={6}
                  name="price"
                  value={data[6].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[25]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={6} name="vat" value={data[6].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={7}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"b"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent", //transparent
                  fontWeight: 400,
                }}
              >
                {"Điều chỉnh giảm"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[26]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={7}
                  name="price"
                  value={data[7].value.price}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[27]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable id={7} name="vat" value={data[7].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={8}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {
                  "Tổng số thuế giá trị gia tăng đầu vào của hàng hóa, dịch vụ mua vào ([28]=[21]+[21a]+[23]+[25]-[27])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[28]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={8}
                  name="vat"
                  readonly="true"
                  value={data[8].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={9}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"5"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {
                  "Thuế giá trị gia tăng mua vào của dự án đầu tư bù trừ với thuế giá trị gia tăng phải nộp của hoạt động sản xuất kinh doanh cùng kỳ tính thuế ([28a]≤[28])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[28a]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable id={9} name="vat" value={data[9].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={10}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"6"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"Thuế giá trị gia tăng mua vào của dự án đầu tư bù trừ với thuế giá trị gia tăng phải nộp của hoạt động sản xuất kinh doanh cùng kỳ tính thuế của chủ đầu tư " +
                  "(trường hợp người nộp thuế được chủ đầu tư giao quản lý dự án đầu tư;([28b]≤[28]-[28a])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[28b]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable id={10} name="vat" value={data[10].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={11}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"7"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {
                  "Thuế giá trị gia tăng đầu vào chưa được hoàn đến kỳ tính thuế của dự án đầu tư ([29]=[28]-[28a]-[28b])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[29]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={11}
                  name="vat"
                  readonly="true"
                  value={data[11].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={12}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"8"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"Thuế giá trị gia tăng đề nghị hoàn ([30]≤[29])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[30]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable id={12} name="vat" value={data[12].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={13}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"9"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {
                  "Thuế giá trị gia tăng đầu vào của dự án đầu tư chưa được hoàn bàn giao trong kỳ ([31]≤[29]-[30])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                {"[31]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: "bold",
                }}
              >
                <InputTable id={13} name="vat" value={data[13].value.vat} onChange={handleChange} />
              </Td>
            </tr>
            <tr key={14}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"10"}
              </Td>
              <Td
                colSpan={3}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {
                  "Thuế giá trị gia tăng đầu vào của dự án đầu tư chưa được hoàn chuyển kỳ ([32]≤[29]-[30]-[31])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"[32]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={14}
                  name="vat"
                  readonly="true"
                  value={data[14].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 20,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontSize: "14px",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
